import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Navbar() {
  const { t } = useTranslation();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { to: '/', label: t('nav.home') },
    { to: '/category/wanghong-heiliao', label: t('nav.category') },
    { to: '/category/hot', label: t('nav.hot') },
    { to: '/about', label: t('nav.about') },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link
            to="/"
            className={`font-heading text-xl md:text-2xl font-bold whitespace-nowrap transition-colors duration-300 ${
              scrolled ? 'text-primary-700' : 'text-white'
            }`}
          >
            {t('site.name')}
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium whitespace-nowrap transition-colors duration-300 hover:text-accent-400 ${
                  location.pathname === link.to
                    ? scrolled
                      ? 'text-primary-600'
                      : 'text-accent-400'
                    : scrolled
                      ? 'text-foreground-700'
                      : 'text-white/90'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="flex items-center gap-4">
            <button
              className={`hidden md:inline-flex items-center gap-2 rounded-full border px-5 py-2 text-sm font-medium whitespace-nowrap transition-all duration-300 cursor-pointer ${
                scrolled
                  ? 'border-primary-500 text-primary-600 hover:bg-primary-500 hover:text-white'
                  : 'border-white/60 text-white hover:bg-white hover:text-primary-700'
              }`}
            >
              <i className="ri-user-line w-4 h-4 flex items-center justify-center"></i>
              <span>{t('nav.login')}</span>
            </button>

            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer transition-colors duration-300 ${
                scrolled ? 'text-foreground-800' : 'text-white'
              }`}
              aria-label="菜单"
            >
              <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-6 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium py-2 whitespace-nowrap ${
                  location.pathname === link.to
                    ? 'text-primary-600'
                    : 'text-foreground-700'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <button className="mt-2 inline-flex items-center justify-center gap-2 rounded-full border border-primary-500 px-5 py-2 text-sm font-medium text-primary-600 whitespace-nowrap cursor-pointer hover:bg-primary-500 hover:text-white transition-all duration-300">
              <i className="ri-user-line w-4 h-4 flex items-center justify-center"></i>
              <span>{t('nav.login')}</span>
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}